import React from "react";
import { Container, FileElement, Label, GroupElement, PrimaryButton, SecondaryButton, Preview, Image } from "./styles/imageUpload";


export default function ImageUploadCantainer({children, ...props}){
    return <Container {...props}>{children}</Container>
}

ImageUploadCantainer.FileElement = function ImageUploadCantainerFileElement({...props}){
    return <FileElement {...props} />
}

ImageUploadCantainer.Label = function ImageUploadCantainerLabel({children, ...props}){
    return <Label {...props}>{children}</Label>
}

ImageUploadCantainer.GroupElement = function ImageUploadCantainerGroupElement({children, ...props}){
    return <GroupElement {...props}>{children}</GroupElement>
}

ImageUploadCantainer.PrimaryButton = function ImageUploadCantainerPrimaryButton({children, ...props}){
    return <PrimaryButton {...props}>{children}</PrimaryButton>
}

ImageUploadCantainer.SecondaryButton = function ImageUploadCantainerSecondaryButton({children, ...props}){
    return <SecondaryButton {...props}>{children}</SecondaryButton>
}

ImageUploadCantainer.Preview = function ImageUploadCantainerPreview({children, ...props}){
    return <Preview {...props}>{children}</Preview>
}

ImageUploadCantainer.Image = function ImageUploadCantainerImage({...props}){
    return <Image {...props} />
}
